import axios from "axios";

const API_URL = process.env.REACT_APP_SHAREPOINT_API_URL;

const getCommonDocuments = async () => {
  const config = {
    headers: {
      'Content-Type': 'application/json',
      'x-access-token': JSON.parse(localStorage.getItem("user")).accessToken
    }
  }
  
  let response = await axios.post(API_URL + "getCommonDocuments", {email: JSON.parse(localStorage.getItem("user")).email}, config)
  return response.data
};

const getUserDocuments = async () => {
  const config = {
    headers: {
      'Content-Type': 'application/json',
      'x-access-token': JSON.parse(localStorage.getItem("user")).accessToken
    }
  }

    let response = await axios.post(API_URL + "getUserDocuments", {email: JSON.parse(localStorage.getItem("user")).email}, config)
    return response.data
};

const getDownloadCommonFile = async (reqfile, fileStatus = true) => {
  const config = {
    responseType: 'blob',
    headers: {
      'x-access-token': JSON.parse(localStorage.getItem("user")).accessToken
    }
  }

  const data = {
    email: JSON.parse(localStorage.getItem("user")).email, 
    file: reqfile,
    status: fileStatus
  }

  let response = await axios.post(API_URL + "getDownloadCommonFile", data, config)
  return response.data
} 

const getDownloadUserFile = async (reqfile, fileStatus = true) => {
  const config = {
    responseType: 'blob',
    headers: {
      'x-access-token': JSON.parse(localStorage.getItem("user")).accessToken
    }
  }

  const data = {
    email: JSON.parse(localStorage.getItem("user")).email, 
    file: reqfile,
    status: fileStatus
  }

  let response = await axios.post(API_URL + "getDownloadUserFile", data, config)
  return response.data
}

const getCustomerManager = async(email) => {
  const config = {
    headers: {
      'Content-Type': 'application/json',
      'x-access-token': JSON.parse(localStorage.getItem("user")).accessToken
    }
  }

    let response = await axios.post(API_URL + "getCustomerManager", {email: email}, config)
    return response.data
}

const getReklamationen = async() => {
  const config = {
    headers: {
      'Content-Type': 'application/json',
      'x-access-token': JSON.parse(localStorage.getItem("user")).accessToken
    }
  }

    let response = await axios.post(API_URL + "getReklamationen", {email: JSON.parse(localStorage.getItem("user")).email}, config)
    return response.data
}

const getProjectVideos = async() => {
  const config = {
    headers: {
      'Content-Type': 'application/json',
      'x-access-token': JSON.parse(localStorage.getItem("user")).accessToken
    }
  }

    let response = await axios.post(API_URL + "getProjectVideos", {email: JSON.parse(localStorage.getItem("user")).email}, config)
    console.log(response.data)
    return response.data
}

const getCommonVideos = async() => {
  const config = {
    headers: {
      'Content-Type': 'application/json',
      'x-access-token': JSON.parse(localStorage.getItem("user")).accessToken
    }
  }

    let response = await axios.post(API_URL + "getCommonVideos", {email: JSON.parse(localStorage.getItem("user")).email}, config)
    console.log(response.data)
    return response.data
}

const createWarranty = async(data) => {  
  var formData = new FormData();

  for (const [key, value] of Object.entries(data)) {
    if (key === 'files' && Array.isArray(value)) {
      // GEÄNDERT: Alle Files unter dem gleichen Feldnamen 'files'
      value.forEach((file) => {
        formData.append('files', file);  // ← OHNE [index]
      });
    } else if (Array.isArray(value)) {
      value.forEach((v, i) => formData.append(`${key}[${i}]`, v));
    } else if (value !== undefined && value !== null) {
      formData.append(key, value);
    }
  }

  const config = {
    headers: {
      'Content-Type': 'multipart/form-data',
      'x-access-token': JSON.parse(localStorage.getItem("user")).accessToken
    }
  }

  const result = await axios.post(API_URL + "createWarranty", formData, config);
  return result;
}

const getWohnungenForCustomer = async() => {
  const config = {
    headers: {
      'Content-Type': 'application/json',
      'x-access-token': JSON.parse(localStorage.getItem("user")).accessToken
    }
  }

  let response = await axios.post(API_URL + "getWohnungenForCustomer", {
    email: JSON.parse(localStorage.getItem("user")).email
  }, config);
  return response.data;
}


const getCustomersForHausverwaltung = async() => {
  const config = {
    headers: {
      'Content-Type': 'application/json',
      'x-access-token': JSON.parse(localStorage.getItem("user")).accessToken
    }
  }

  let response = await axios.post(API_URL + "getCustomersForHausverwaltung", {}, config);
  return response.data;
}

const getProjekteForHausverwaltung = async() => {
  const config = {
    headers: {
      'Content-Type': 'application/json',
      'x-access-token': JSON.parse(localStorage.getItem("user")).accessToken
    }
  }

  let response = await axios.post(API_URL + "getProjekteForHausverwaltung", {}, config);
  return response.data;
}

const getWohnungenByProjekt = async(projektId) => {
  const config = {
    headers: {
      'Content-Type': 'application/json',
      'x-access-token': JSON.parse(localStorage.getItem("user")).accessToken
    }
  }

  let response = await axios.post(API_URL + "getWohnungenByProjekt", { projektId }, config);
  return response.data;
}

const SharePointService = {
    getCommonDocuments,
    getUserDocuments,
    getDownloadCommonFile,
    getCustomerManager,
    getReklamationen,
    getProjectVideos,
    getCommonVideos,
    getDownloadUserFile,
    getWohnungenForCustomer,
    getCustomersForHausverwaltung,
    getProjekteForHausverwaltung,
    getWohnungenByProjekt,
    createWarranty
}

export default SharePointService;